import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CategoryNav, CategoriesFilter, MapView } from '../../components'
import { Hotels } from './components'

export default (props: any) => {
    const [showCategories, setShowCategories] = useState(false)
    const [showMap, setShowMap] = useState(false)
    const { t } = useTranslation()
    const categoriesToggle = () => setShowCategories(!showCategories)
    const mapToggle = () => setShowMap(!showMap)

    return (
        <div>
            <CategoryNav />
            <div className="body-wrapper clearfix p-t0">
                <ul className="medium-block-grid-4 small-block-grid-2 third-nav">
                    <li className="active">
                        <button>
                            <img src="/images/icons/icon-360.png" alt="icon-360" /> {t('Partners')}
                        </button>
                    </li>
                    <li>
                        <button>
                            <img src="/images/icons/icon-360.png" alt="icon-360" /> {t('Recommendations')}
                        </button>
                    </li>
                    <li>
                        <button>
                            <img src="/images/icons/small-icon-hotels.png" alt="icon-360" /> {t('Online Booking')}
                        </button>
                    </li>
                    <li>
                        <button>
                            <img src="/images/icons/hotel-plus-flight.png" alt="icon-360" /> {t('Bundled Hotel & Flights')}
                        </button>
                    </li>
                </ul>
                <div className="hotel-wrapper">
                    <div className="hotel-body">
                        <div className={'page-header'}>
                            <div className="page-title clearfix">
                                <h4 className="fl">
                                    102 {t('Hotels Found in')} Germany
                                </h4>
                            </div>
                            <div className="tool-bar">
                                <label className="p-r5">{t('Sort by')}: </label>
                                <select className="small">
                                    <option>Date</option>
                                    <option>Date 1</option>
                                    <option>Date 2</option>
                                </select>

                                <div className="toggle-button">
                                    <button className={`grid ${!showMap ? 'active' : ''}`} onClick={mapToggle}>
                                        {t('Grid')}
                                    </button>
                                    <button className={`map ${showMap ? 'active' : ''}`} onClick={mapToggle}>
                                        {t('Map')}
                                    </button>
                                </div>
                                <div className="toggle-button">
                                    <button className={`category ${showCategories ? 'active' : ''}`} onClick={categoriesToggle}>
                                        {t('Category')}
                                    </button>
                                    <button className="location">
                                        {t('Location')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="tour-wrapper">
                            <div className={`grid-n-map-view ${showMap && 'map-view'}`}>
                                <Hotels />
                                {showMap && <MapView data={[]}/>}
                            </div>
                            <CategoriesFilter
                                filterShow={showCategories}
                                countryId={1}
                                applyFilter={() => {}}
                                resetFilter={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}